export default "__VITE_ASSET__dee5fe49__"